export default "__VITE_ASSET__CuEt3UDJ__"